import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen bg-[#0A0A0A] overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md' : 'bg-transparent'}`}>
        <div className="max-w-[1600px] mx-auto px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/5b9bd2cbb4f3f977486d4a8e60efd124.jpeg" 
              alt="BillPlay Apparel" 
              className="h-12 w-auto"
            />
          </Link>
          <div className="hidden md:flex items-center gap-10">
            <Link to="/new-arrivals" className="text-white/90 hover:text-white text-sm font-medium tracking-wide transition-colors whitespace-nowrap">NEW ARRIVALS</Link>
            <Link to="/apparel" className="text-white/90 hover:text-white text-sm font-medium tracking-wide transition-colors whitespace-nowrap">APPAREL</Link>
            <Link to="/footwear" className="text-white/90 hover:text-white text-sm font-medium tracking-wide transition-colors whitespace-nowrap">FOOTWEAR</Link>
            <Link to="/accessories" className="text-white/90 hover:text-white text-sm font-medium tracking-wide transition-colors whitespace-nowrap">ACCESSORIES</Link>
            <Link to="/story" className="text-white/90 hover:text-white text-sm font-medium tracking-wide transition-colors whitespace-nowrap">OUR STORY</Link>
          </div>
          <div className="flex items-center gap-6">
            <button className="text-white/90 hover:text-white transition-colors" aria-label="Search">
              <i className="ri-search-line text-xl"></i>
            </button>
            <button className="text-white/90 hover:text-white transition-colors" aria-label="Cart">
              <i className="ri-shopping-bag-line text-xl"></i>
            </button>
            <button className="md:hidden text-white/90 hover:text-white transition-colors" aria-label="Menu">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative h-screen flex items-center">
        <div className="max-w-[1600px] mx-auto px-8 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left - Image */}
            <div className="relative h-[600px] md:h-[700px] rounded-2xl overflow-hidden">
              <img 
                src="https://storage.readdy-site.link/project_files/e1dfa5f9-76f3-4380-a103-7aa6f939f431/834c61b9-2700-41e2-85ba-ba4ecd228395_billplayhero.jpg?v=2e7c63dd64e7a3f5e2b29d24df2a18b0"
                alt="BillPlay Streetwear"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            </div>

            {/* Right - Text */}
            <div className="space-y-8">
              <div className="space-y-4">
                <h1 className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-[0.9] tracking-tight">
                  BUILT FROM<br />
                  THE NORTHSIDE<br />
                  <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">SINCE 2017</span>
                </h1>
              </div>
              
              <p className="text-lg text-gray-300 max-w-lg leading-relaxed">
                Kalamazoo roots. Nationwide reach. Culture over everything.
              </p>

              <div className="flex flex-col gap-4 pt-4">
                <Link 
                  to="/new-arrivals" 
                  className="bg-white text-black px-10 py-4 rounded-lg font-bold text-sm tracking-wide hover:scale-105 hover:shadow-2xl hover:shadow-white/20 transition-all duration-300 text-center whitespace-nowrap"
                >
                  SHOP NEW ARRIVALS
                </Link>
                <Link 
                  to="/story" 
                  className="border-2 border-white text-white px-10 py-4 rounded-lg font-bold text-sm tracking-wide hover:bg-white hover:text-black transition-all duration-300 text-center whitespace-nowrap"
                >
                  VIEW BRAND STORY
                </Link>
                <Link 
                  to="/shop" 
                  className="text-white text-sm font-medium hover:underline flex items-center gap-2 justify-center whitespace-nowrap"
                >
                  SHOP ALL <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}